import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { DynamicFormDesignerConfig } from '../utils/dynamic-form-designer-config';
import { Condition } from '../types';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ShowSettingServiceService {
  constructor(private http: HttpClient, private config: DynamicFormDesignerConfig) {}

  getCondition(formCode: string): Observable<Condition> {
    const url = this.getUrl(`/${formCode}/condition`);
    return this.http.get<{ selectCondition: string; showCondition: string }>(url).pipe(
      map((s) => {
        if (!s) {
          return { selectCondition: [], showCondition: [] };
        }
        return {
          selectCondition: JSON.parse(s.selectCondition),
          showCondition: JSON.parse(s.showCondition)
        };
      })
    );
  }

  getUrl(url: string): string {
    return this.config.serviceUrl + 'dynamicform/formdatas' + url;
  }
}
